import { FC } from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { DisturbanceFormKey } from '../MessageForms.types';

import { DisturbanceCommonSpacesForm } from './DisturbanceCommonSpacesForm';
import { DisturbanceNeighbourForm } from './DisturbanceNeighbourForm';
import { DisturbanceOtherForm } from './DisturbanceOtherForm';

export const disturbanceForms: Record<
  DisturbanceFormKey,
  FC<ParsedEntry<IWidget>>
> = {
  [DisturbanceFormKey.DISTURBANCE_NEIGHBOUR]: DisturbanceNeighbourForm,
  [DisturbanceFormKey.DISTURBANCE_COMMON_SPACES]: DisturbanceCommonSpacesForm,
  [DisturbanceFormKey.DISTURBANCE_OTHER]: DisturbanceOtherForm,
};
